"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caorle": {
    "eb782672": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "skipSearch": false
    }],
    "brian": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d8e35c26": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "skipSearch": false
    }],
    "brussa": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3cfd16da": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "skipSearch": false
    }],
    "ca-corniani": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eaa75ddc": [{
      "hkey": "437267f1",
      "slug": "duna-verde-lido-altanea",
      "name": "Duna Verde-Lido Altanea",
      "primary": true,
      "skipSearch": false
    }],
    "duna-verde": [{
      "hkey": "437267f1",
      "slug": "duna-verde-lido-altanea",
      "name": "Duna Verde-Lido Altanea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "16361a82": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "skipSearch": false
    }],
    "falconera": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "551e506f": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "skipSearch": false
    }],
    "san-gaetano": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "411a0a14": [{
      "hkey": "a0ae8e5a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "sansonessa": [{
      "hkey": "a0ae8e5a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caorle"
    }],
    "547a27cf": [{
      "hkey": "8743a47a",
      "slug": "porto-santa-margherita",
      "name": "Porto Santa Margherita",
      "primary": true,
      "skipSearch": false
    }],
    "santa-margherita": [{
      "hkey": "8743a47a",
      "slug": "porto-santa-margherita",
      "name": "Porto Santa Margherita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caorle"
    }],
    "d8604e65": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "skipSearch": false
    }],
    "villaviera": [{
      "hkey": "ec67f48a",
      "slug": "caorle",
      "name": "Caorle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;